module.exports = __webpack_public_path__ + "static/media/reynolds.ad00b24c.png";